/**
 * Buttons with iFrames.
 *
 * @return {void}
 */
export const ButtonIframe = () => {

	const buttons = document.querySelectorAll( '.js-wp-block-button--iframe' )
	const popup = document.getElementById( 'popup' )
	const popupContent = document.querySelector( '.popup__content' )
	const iframe = document.querySelector( '.popup__iframe' )

	if ( ! buttons ) {

		return null

	}

	buttons.forEach( ( button ) => {

		if ( ! button ) {

			return null

		}

		button.addEventListener( 'click', ( e ) => {

			e.preventDefault()

			iframe.style.display = 'block'
			popup.classList.add( 'popup--with-iframe' )
			popup.classList.add( 'popup--opened-from-native-button' )
			popup.style.opacity = 1
			popup.style.visibility = 'visible'

		} )

	} )

	popup.addEventListener( 'click', ( e ) => {

		if ( ! popupContent.contains( e.target ) && popup.classList.contains( 'popup--opened-from-native-button' ) ) {

			popup.classList.remove( 'popup--opened-from-native-button' )
			popup.classList.remove( 'popup--with-iframe' )
			popup.style.opacity = ''
			popup.style.visibility = ''
			iframe.style.display = 'none'

		}

	} )

}
